import { Exception } from "./Exception";
import { ErrorSeverity } from "./ErrorSeverity";

export class ForbiddenException extends Exception {
  constructor({ message, response, stack }: { message: string; response: Response; stack?: string }) {
    super({
      errorSeverity: ErrorSeverity.WARNING,
      useErrorBoundary: false,
      name: "ForbiddenException",
      message,
      response,
      stack,
    });
  }
}
